import React, { useState } from 'react';
import { 
  Container, Grid, Card, CardMedia, CardContent, Typography, 
  Dialog, DialogContent, Box, useTheme 
} from '@mui/material';

const programs = [
  {
    title: 'July Holiday Program',
    image: 'images/schedules/HP_July_2025.png', 
    startDate: 'Tuesday 01/07/25',
    endDate: 'Thursday 17/07/25',
  },
]
const ProgramShowcase = () => {
  const theme = useTheme();
  const oppocolor = theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark;
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');

  const handleImageClick = (image) => {
    setCurrentImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, padding: 0 }}>
      <Grid container spacing={4} direction="column">
        {programs.map((program, index) => (
          <Grid item xs={12} key={index}>
            <Card 
              sx={{ 
                display: 'flex', 
                flexDirection: { 
                  xs: 'column', 
                  md: index % 2 === 0 ? 'row' : 'row-reverse' 
                },
                borderRadius: 3, 
                boxShadow: 3, 
                overflow: 'hidden', 
                position: 'relative',
                backgroundColor: oppocolor,
                height: { xs: 'auto', md: 300 }, // auto on mobile
              }}
            >
              {/* Clickable Image with Hover Effect */}
              <Box
                sx={{
                  width: { xs: '100%', md: '70%' },
                  height: { xs: '50%', md: '100%' }, // 👈 half height on mobile
                  position: 'relative',
                  '&:hover .hover-overlay': {
                    opacity: 1,
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={program.image}
                  alt={program.title}
                  onClick={() => handleImageClick(program.image)}
                  sx={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover', 
                    cursor: 'pointer',
                  }}
                />

                {/* Hover Overlay */}
                <Box
                  className="hover-overlay"
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: 0,
                    transition: 'opacity 0.3s ease-in-out',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleImageClick(program.image)}
                >
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      color: '#fff', 
                      textAlign: 'center',
                      fontSize: '1rem',
                    }}
                  >
                    Click for full image
                  </Typography>
                </Box>
              </Box>

              {/* Text Content */}
              <CardContent 
                sx={{ 
                  width: { xs: '100%', md: '30%' },
                  height: { xs: '50%', md: '100%' }, // 👈 half height on mobile
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  textAlign: 'left',
                  padding: 3,
                }}
              >
                <Typography 
                  variant="h5" 
                  gutterBottom 
                  sx={{ color: theme.palette.background.default, fontWeight: 'bold' }}
                >
                  {program.title}
                </Typography>
                <Typography 
                  variant="h6" 
                  
                  sx={{ color: theme.palette.background.default,fontSize: '1rem', }}
                >
                  Start Date: {program.startDate}
                </Typography>

                <Typography 
                  variant="h6" 
                  sx={{ color: theme.palette.background.default, fontSize: '1rem',}}
                >
                 End Date: {program.endDate}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Full View Image Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            width: {
              xs: '90%',  // 🚀 make it 90% width of screen on mobile
              sm: '80%',  // medium screens
              md: '70%',  // desktop
            },
            maxWidth: 'none',  // 💥 disable MUI’s default maxWidth
            m: { xs: 1, sm: 2, md: 3 },  // margin around the dialog
            borderRadius: 2,
          },
        }}
      >
        <DialogContent>
          <Box
            component="img"
            src={currentImage}
            alt="Full View"
            sx={{
              width: '100%', 
              height: 'auto', 
              borderRadius: 2,
            }}
          />
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default ProgramShowcase;